export const COLORS = {
  oneGp: {
    mist: '#f8f8f8',
    haze: '#f4f4f4',
    fog: '#EEEEEE',
    smoke: '#c4c4c4',
    charcoal: '#595959',
    black: '#000000',
    white: '#ffffff',
    globalBlue: '#262aff',
    deepBlue: '#1b1ec6'
  },
  biDashboard: {
    pulseBlue: '#1cabff',
    sunshine: '#ffcc00',
    creamsicle: '#fda052',
    raspberry: '#f4364c',
    grape: '#87179d'
  }
};
